import React, { useState, useEffect } from 'react';
import './GroupParam.css';
import './BelbenResult.css';
import LineBig from '../media/imagen/Line BIG.png';

// Компонент для отображения шкалы
const ProgressScale = ({ title, score }) => {
  const maxScore = 20;
  const totalBars = 20;
  const filledCount = Math.min(score, maxScore);
  
  // Функция для вычисления цвета
  const getBarColor = () => {
    if (score === 0) return '#CCD3DE';
    if (score >= maxScore) return '#1A62CE';
    
    const startColor = { r: 197, g: 220, b: 255 };
    const endColor = { r: 26, g: 98, b: 206 };
    
    // Рассчитываем соотношение для градиента
    const ratio = (score - 1) / (maxScore - 1);
    
    const r = Math.round(startColor.r + ratio * (endColor.r - startColor.r));
    const g = Math.round(startColor.g + ratio * (endColor.g - startColor.g));
    const b = Math.round(startColor.b + ratio * (endColor.b - startColor.b));
    
    return `rgb(${r}, ${g}, ${b})`;
  };

  const barColor = getBarColor();
  const displayScore = Number.isInteger(score) ? score : score.toFixed(1);

  return (
    <div className="scale-container">
      <div className="scale-title">{title}</div>
      <div className="scale-bars">
        {Array.from({ length: totalBars }).map((_, index) => (
          <div 
            key={index}
            className="scale-bar"
            style={{
              backgroundColor: index < filledCount ? barColor : '#F0F4F8',
            }}
          />
        ))}
      </div>
      <div className="scale-score">{displayScore}</div>
    </div>
  );
};

// Основной компонент
const BelbenResult = ({ testID }) => {
  const [statusData, setStatusData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [testData, setTestData] = useState(null);
  const [userResults, setUserResults] = useState([]);

  // Маппинг ролей и их описаний
  const roleMapping = {
    'CF': {
      title: 'Контролёр',
      description: 'Добросовестный и тревожный. Этот сотрудник, как правило, завершает проект, «причёсывает» работу всей команды. Он аккуратен и внимателен, требователен к деталям, не любит делегировать, перфекционист. С виду спокойный интроверт, но внутри часто переживает, иногда больше, чем нужно. Педант душой болеет за результат и ответственно подходит к своей работе.'
    },
    'CO': {
      title: 'Душа команды',
      description: 'Мягкий и дипломатичный. Популярный человек в команде. Обладает эмпатией, создаёт в коллективе дружескую атмосферу, помогает решить конфликты между коллегами.'
    },
    'ME': {
      title: 'Мотиватор',
      description: 'Энергичный и ориентированный на успех. Такой сотрудник сам обладает высоким уровнем мотивации и мотивирует других. Ему нравится вести за собой команду и он неплохо с этим справляется. Не терпит неудач и чувствительно на них реагирует.'
    },
    'PL': {
      title: 'Координатор',
      description: 'Уверенный организатор. Обычно это лидер команды. Он распределяет задачи, устанавливает сроки выполнения, контролирует результат. Он хорошо знает свою команду и умело пользуется возможностями каждого сотрудника.'
    },
    'RI': {
      title: 'Аналитик-стратег',
      description: 'Объективный и проницательный. Анализирует возможности по проекту, редко ошибается в оценке ситуации. Хладнокровный, часто интроверт. Полезен на стадии стратегического планирования.'
    },
    'SH': {
      title: 'Генератор идей',
      description: 'Изобретатель и новатор. Как правило, это руководитель команды. Полезен на начальных стадиях проекта, либо когда рабочий процесс застопорился и необходим драйвер для продолжения движения.'
    },
    'TW': {
      title: 'Специалист',
      description: 'Целеустремлённый эксперт. Делится необходимыми знаниями с командой, профессионал в своей области. Полезен в начале проекта, когда нужно проверить технические нюансы.'
    },
    'IMP': {
      title: 'Исследователь ресурсов',
      description: 'Харизматичный энтузиаст, экстраверт. Умеет налаживать отношения, грамотно вести переговоры и договариваться о выгодных условиях с подрядчиками или новыми клиентами.'
    }
  };

  // Порядок отображения шкал
  const scaleOrder = ['CF', 'CO', 'ME', 'PL', 'RI', 'SH', 'TW', 'IMP'];

  useEffect(() => {
    const fetchStatusData = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) throw new Error('Токен авторизации не найден');

        const response = await fetch(
          `http://185.250.149.189:8000/api/v1/Results/Belben?test_id=${testID}`,
          {
            method: 'GET',
            headers: {
              'Authorization': `Token ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );

        if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);
        const result = await response.json();
        setStatusData(result);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchStatusData();
  }, [testID]);
  
    useEffect(() => {
        console.log(statusData)
    }, [statusData]);
  useEffect(() => {
    const fetchTestData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('authToken');
        if (!token) throw new Error('Токен авторизации не найден');

        const response = await fetch(`http://185.250.149.189:8000/api/v1/Test?id=${testID}`, {
          headers: { 'Authorization': `Token ${token}` }
        });

        if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);
        
        const data = await response.json();
        
        if (!data.tests || data.tests.length === 0) {
          throw new Error('Тест не найден');
        }
        
        const test = data.tests[0];
        setTestData(test);

      } catch (error) {
        console.error('Ошибка загрузки данных теста:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTestData();
  }, [testID]);

  // Объединяем данные из двух запросов
  useEffect(() => {
    if (statusData && testData) {
      const combinedData = statusData.results.map(result => {
        // Находим пользователя в группе
        const user = testData.group.users.find(u => u.user_id === result.user_id);
        const userName = user ? user.user_name : `Пользователь ${result.user_id}`;
        
        // Находим две роли с наибольшими баллами
        const roles = Object.entries(result.result)
          .sort((a, b) => b[1] - a[1])
          .slice(0, 2);
        
        // Проверяем на случай одинаковых баллов
        const mainRole = roles[0][0];
        let secondaryRole = roles[1][0];
        
        // Если баллы совпадают, сохраняем порядок из scaleOrder
        if (roles[0][1] === roles[1][1]) {
          const mainIndex = scaleOrder.indexOf(mainRole);
          const secondaryIndex = scaleOrder.indexOf(secondaryRole);
          if (secondaryIndex < mainIndex) {
            [secondaryRole, mainRole] = [mainRole, secondaryRole];
          }
        }
        
        return {
          user_id: result.user_id,
          user_name: userName,
          result: result.result,
          mainRole: {
            code: mainRole,
            ...roleMapping[mainRole],
            score: result.result[mainRole]
          },
          secondaryRole: {
            code: secondaryRole,
            ...roleMapping[secondaryRole],
            score: result.result[secondaryRole]
          }
        };
      });
      
      setUserResults(combinedData);
    }
  }, [statusData, testData]);

  if (loading) return <div className="loading">Загрузка данных...</div>;
  if (error) return <div className="error">Ошибка: {error}</div>;
  if (!statusData || !testData) return <div className="no-data">Нет данных для отображения</div>;

  return (
    <div className="scales-block">
      {userResults.map(user => (
        <div className='BelbenResultContainer' key={user.user_id}>
          <div className='PersonalBelbenResultDes'>
            <h2>{user.user_name}</h2>
            <div className='Integralball'>
              <div className='IntegraText1'>
                <h4>Ведущая роль</h4>
                <h3>{user.mainRole.title} ({user.mainRole.code})</h3>
                <span>{user.mainRole.description}</span>
              </div>
              <img 
                src={LineBig} 
                alt="Разделитель ролей" 
              />
              <div className='IntegraText2'>
                <h4>Поддерживающая роль</h4>
                <h3>{user.secondaryRole.title} ({user.secondaryRole.code})</h3>
                <span>{user.secondaryRole.description}</span>
              </div>
            </div>
          </div>

          <div className='ProgressBelbenResult'>
            <div className="scales-columns">
              <div className="scales-column">
                {scaleOrder.slice(0, 4).map(key => (
                  <ProgressScale 
                    key={key}
                    title={`${roleMapping[key].title} (${key})`}
                    score={user.result[key]}
                  />
                ))}
              </div>
              <div className="scales-column">
                {scaleOrder.slice(4).map(key => (
                  <ProgressScale 
                    key={key}
                    title={`${roleMapping[key].title} (${key})`}
                    score={user.result[key]}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BelbenResult;